import React from 'react';
import { NavLink } from 'react-router-dom';

const OnlineMatchTrackingPage = () => {
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-green-100 to-yellow-100 py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-5xl font-bold text-green-800 mb-4">Online Match Tracking</h1>
            <p className="text-xl text-gray-700 mb-8">
              A cloud-based dashboard to log match results and see data trends.
            </p>
            <div className="mb-8">
              <img src="/Images/dashboard.png" alt="Dashboard" className="mx-auto rounded-lg shadow-lg" />
            </div>
            <p className="text-lg text-gray-700 mb-8">
              Your first 5 matches are free to track. Join 500+ players using data to win.
            </p>
            <NavLink to="/login" className="bg-green-500 hover:bg-green-600 text-white font-semibold py-3 px-6 rounded-full text-lg transition duration-300">
              Sign Up / Login
            </NavLink>
          </div>
        </div>
      </section>

      {/* Features */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center text-green-800 mb-12">Why Choose Our Online Service?</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="bg-green-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl">📊</span>
              </div>
              <h3 className="text-xl font-semibold text-green-800 mb-2">Detailed Analytics</h3>
              <p className="text-gray-700">Track your performance with in-depth statistics and trends.</p>
            </div>
            <div className="text-center">
              <div className="bg-yellow-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl">☁️</span>
              </div>
              <h3 className="text-xl font-semibold text-green-800 mb-2">Cloud-Based</h3>
              <p className="text-gray-700">Access your data from anywhere, anytime.</p>
            </div>
            <div className="text-center">
              <div className="bg-green-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl">🏆</span>
              </div>
              <h3 className="text-xl font-semibold text-green-800 mb-2">Win More</h3>
              <p className="text-gray-700">Use data-driven insights to improve your game.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default OnlineMatchTrackingPage;

